/* eslint-disable max-len */
import React from 'react'

export const Eye = () => (
  <svg width="26" height="15" viewBox="0 0 26 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.70689 8.07123C2.92663 6.07388 6.91511 2 12.8534 2C18.7918 2 22.7803 6.07388 24 8.07123L25.7069 7.02886C24.26 4.65951 19.7151 0 12.8534 0C5.99177 0 1.44692 4.65951 0 7.02886L1.70689 8.07123Z" fill="inherit" />
    <path fillRule="evenodd" clipRule="evenodd" d="M1.70689 6C2.92663 7.99735 6.91511 12.0712 12.8534 12.0712C18.7918 12.0712 22.7803 7.99735 24 6L25.7069 7.04237C24.26 9.41172 19.7151 14.0712 12.8534 14.0712C5.99177 14.0712 1.44692 9.41172 0 7.04237L1.70689 6Z" fill="inherit" />
    <circle cx="12.8535" cy="7" r="5" fill="inherit" />
  </svg>
)
